import { Card } from '~ui/base/card';
import { Skeleton } from '~ui/base/skeleton';

const ROW_COUNT = 5;

function DatasetsSkeleton() {
  return (
    <Card ornament="outline" className="p-0">
      <div className="border-b border-border bg-card-highlight/60 px-6 py-3">
        <Skeleton className="h-4 w-24" />
      </div>
      <ul className="divide-y divide-border">
        {Array.from({ length: ROW_COUNT }).map((_, i) => (
          <li key={i} className="flex items-center justify-between gap-x-8 px-6 py-4">
            <div className="flex w-full max-w-md flex-col gap-y-2">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-3 w-2/3" />
            </div>
            <Skeleton className="h-4 w-10" />
            <Skeleton className="h-4 w-16" />
          </li>
        ))}
      </ul>
    </Card>
  );
}

export { DatasetsSkeleton };
